var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#A259FF",
    fillOpacity: 0.13
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 16,
    stroke: "#A259FF",
    strokeWidth: 2.5,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#brainGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 13 Q16 13, 15 19 Q12 26, 18 29 Q15 34, 22 34 Q29 34, 26 29 Q32 26, 29 19 Q28 13, 22 13",
    fill: "none",
    stroke: "#A259FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 19 Q18 21, 21 23",
    stroke: "#A259FF",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19 Q26 21, 23 23",
    stroke: "#A259FF",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 27 Q19 29, 22 31",
    stroke: "#A259FF",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 27 Q25 29, 22 31",
    stroke: "#A259FF",
    strokeWidth: 1,
    fill: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "brainGlow",
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2,
    result: "brainBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "brainBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.ff3ee0c409625dd31117ebc3ba66f13c.svg";
export { ForwardRef as ReactComponent };